import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { useFilters } from '@domain-group/react-hooks'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import useTrainingLesson from '@hooks/useTrainingLesson'
import useTrainingLessons from '@hooks/useTrainingLessons'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import TrainingLessonListItem from './TrainingLessonListItem'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Title',
    },
  ]
}

const TrainingLessons = (props: { trainingModuleId: number }) => {
  const { trainingModuleId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const options = {
    filters: { training_module_id: trainingModuleId, ...pageFilters },
    performHttpRequests: !!trainingModuleId,
  }

  const trainingLessonsPayload = useTrainingLessons(options)
  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredTrainingLessonCount,
    filteredTrainingLessons,
    hasFilteredTrainingLesson,
    loading,
  } = trainingLessonsPayload

  const {
    callbacks: { addTrainingLesson },
  } = useTrainingLesson({ training_module_id: trainingModuleId })

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Training Lessons"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      <Box flexDirection="column">
        {!loading && !hasFilteredTrainingLesson && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Training Lessons present
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              Please assign a Training Lesson below.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredTrainingLesson && (
          // @ts-expect-error TS2322
          <DashboardModule.ScrollableSection flexDirection="column">
            {filteredTrainingLessons.map(trainingLesson => (
              <TrainingLessonListItem
                key={trainingLesson.id}
                trainingLesson={trainingLesson}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredTrainingLessonCount}
          loading={loading}
        >
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => addTrainingLesson()}
            // @ts-expect-error TS2322
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add New Lesson
          </Button>
        </DashboardModule.LoadMoreFooter>
      </Box>
    </DashboardModule>
  )
}

export default TrainingLessons
